import { render, staticRenderFns } from "./MRC_ESS_SpecialTable.vue?vue&type=template&id=2577e380&"
import script from "./MRC_ESS_SpecialTable.vue?vue&type=script&lang=js&"
export * from "./MRC_ESS_SpecialTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VChip,VDataTable,VSheet,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Mega\\MRC\\mrc-ess-fronted\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2577e380')) {
      api.createRecord('2577e380', component.options)
    } else {
      api.reload('2577e380', component.options)
    }
    module.hot.accept("./MRC_ESS_SpecialTable.vue?vue&type=template&id=2577e380&", function () {
      api.rerender('2577e380', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MRC_ESS_SpecialTable.vue"
export default component.exports